import {getCourseRecords} from "../api/course-record";
import {GUIDE_MODE, TRAIN_MODE} from '../lib/constant';

const SET_USER = 'set-user';
const LOGOUT = 'logout';
const SET_PROJECT_INFO = 'set-project-info';
const SET_EDIT_MODE = 'set-edit-mode';
const SET_RECOMMENDED_PROJECTS = 'set-recommended-projects';
const SET_MY_PROJECTS = 'set-my-projects';
const SET_MY_SHARE_PROJECTS = 'set-my-share-projects';
const SET_COURSES = 'set-couses';
const SET_COURSE = 'set-course';
const SET_COURSE_RECORDS = 'set-course-records';
const SET_LESSON = 'set-lesson';
const SET_LESSON_MEMBERS = 'set-lesson-members';
const SET_COURSE_MEMBERS = 'set-course-members';
const SET_CLAZZES = 'set-classes';
const SET_CLAZZ = 'set-class';
const SET_CLAZZ_MEMBERS = 'set-clazz-members';
const SET_TEACH_MODE = 'set-teach-mode';
const SET_CHAT_STEPS = 'set-chat-cards';
const SET_CHAT_BUTTONS = 'set-chat-buttons';
const SET_STEP_PROGRESS = 'set-step-progress';
const SET_STEP_MODE = 'set-step-mode';

const CLOSE_MODAL = 'close-modal';
const OPEN_MODAL = 'open-modal';
//不同Modal对应的状态
const MODAL_LOGIN = 'loginModal';

const SET_CHAT_BOX = 'set-chat-box';

const SET_PHONE = 'set-phone';

const SET_KEYBORD = 'set-keyboard';




const teachInitialState = {
    user: {},
    projectInfo: null,
    isEditMode: false, //是否为模板编辑模式
    recommendedProjects: {data: []},
    myProjects: {data: []},
    shareProjects:{data:[]},
    courses: {
        data: []
    },
    course: {name: "", lessons: []},
    courseRecords: {data: []},
    lesson: {name: "", tasks: [], homeworks: [], record: {current_task: -1}},
    courseMembers: {course_id: undefined, clazz_id: undefined, data: []},
    lessonMembers: {course_id: undefined, clazz_id: undefined, lesson_id: undefined, data: []},
    clazzes: {
        data: []
    },
    clazz: {name: "", courses: {data: []}},
    clazzMembers: {clazz_id: undefined, data: []},
    [MODAL_LOGIN]: false,
    loadingText: undefined,
    teachMode: GUIDE_MODE,
    chatSteps: [], //聊天框中的step列表
    chatButtons: [], //底部的交互按钮
    stepProgress: 0, //引导步骤进度
    stepMode: TRAIN_MODE, //引导模式
    isChatBox: false, //是否有聊天框
    isPhone:false,  //是否在移动端
    keyboard:0 //移动端软键盘显示
};

const teachReducer = function(state = teachInitialState, action) {
    switch (action.type) {
        case SET_USER:
            //存储api_token
            if (action.payload && action.payload.api_token) {
                window.config.apiToken = action.payload.api_token;
                localStorage.setItem('api-token', window.config.apiToken);
            }
            return {
                ...state,
                user: action.payload
            }
        case LOGOUT:
            window.config.apiToken = null;
            localStorage.removeItem('api-token');
            setTimeout(() => {
                if (window.__wxjs_environment === 'miniprogram') {
                    window.config.apiToken = null;
                    localStorage.removeItem('api-token');
                    wx.miniProgram.navigateTo({ url: '/pages/logout/logout' });
                } 
            }, 500);
            return {
                ...state,
                user: {},
                myProjects: teachInitialState.myProjects,
                courseRecords: teachInitialState.courseRecords,
                courses: teachInitialState.courses
            }
        case SET_PROJECT_INFO:
            return {
                ...state,
                projectInfo: action.payload
            }
        case SET_EDIT_MODE:
            return {
                ...state,
                isEditMode: action.payload
            }
        case SET_RECOMMENDED_PROJECTS:
            return {
                ...state,
                recommendedProjects: action.payload
            }
        case SET_MY_PROJECTS:
            return {
                ...state,
                myProjects: action.payload
            }
        case SET_MY_SHARE_PROJECTS:
            return {
                ...state,
                shareProjects: action.payload
            }
        case SET_COURSES:
            return {
                ...state,
                courses: action.payload
            }
        case SET_COURSE:
            return {
                ...state,
                course: action.payload
            }
        case SET_COURSE_RECORDS:
            return {
                ...state,
                courseRecords: action.payload
            }
        case SET_COURSE_MEMBERS:
            return {
                ...state,
                courseMembers: action.payload
            }
        case SET_LESSON:
            return {
                ...state,
                lesson: action.payload
            }
        case SET_LESSON_MEMBERS:
            return {
                ...state,
                lessonMembers: action.payload
            }
        case SET_CLAZZES:
            return {
                ...state,
                clazzes: action.payload
            }
        case SET_CLAZZ:
            return {
                ...state,
                clazz: action.payload
            }
        case SET_CLAZZ_MEMBERS:
            return {
                ...state,
                clazzMembers: action.payload
            }
        case SET_TEACH_MODE:
            return {
                ...state,
                teachMode: action.payload
            }
        case SET_CHAT_STEPS:
            return {
                ...state,
                chatSteps: action.payload
            }
        case SET_CHAT_BUTTONS:
            return {
                ...state,
                chatButtons: action.payload
            }
        case SET_STEP_PROGRESS:
            return {
                ...state,
                stepProgress: action.payload
            }
        case SET_STEP_MODE:
            return {
                ...state,
                stepMode: action.payload
            }
        case CLOSE_MODAL:
            return {
                ...state,
                [action.payload]: false
            }
        case OPEN_MODAL:
            return {
                ...state,
                [action.payload]: true
            }
        case SET_CHAT_BOX:
            return {
                ...state,
                isChatBox: action.payload
            }
        case SET_PHONE:
            return {
                ...state,
                isPhone: action.payload
            }
        case SET_KEYBORD:
            return {
                ...state,
                keyboard: action.payload
            }
        default:
            return state;
    }
}

const setUser = user => ({
    type: SET_USER,
    payload: user
});

const logout = () => ({
    type: LOGOUT
});

//设置当前项目信息（不包含src的部分）
const setProjectInfo = info => ({
    type: SET_PROJECT_INFO,
    payload: info
});

const setEditMode = isEditMode => ({
    type: SET_EDIT_MODE,
    payload: isEditMode
})
const setRecommendedProjects = projects => ({
    type: SET_RECOMMENDED_PROJECTS,
    payload: projects
});

const setMyProjects = projects => ({
    type: SET_MY_PROJECTS,
    payload: projects
})

const setMyShareProjects = projects => ({
    type: SET_MY_SHARE_PROJECTS,
    payload: projects
})

const setCourses = courses => ({
    type: SET_COURSES,
    payload: courses
});

const setCourse = course => ({
    type: SET_COURSE,
    payload: course
});

const setCourseRecords = courseRecords => ({
    type: SET_COURSE_RECORDS,
    payload: courseRecords
});

const setCourseMembers = members => ({
    type: SET_COURSE_MEMBERS,
    payload: members
});

const setLesson = lesson => ({
    type: SET_LESSON,
    payload: lesson
});

const setLessonMembers = members => ({
    type: SET_LESSON_MEMBERS,
    payload: members
});

const setClazzes = clazzes => ({
    type: SET_CLAZZES,
    payload: clazzes
});

const setClazz = clazz => ({
    type: SET_CLAZZ,
    payload: clazz
});

const setClazzMembers = members => ({
    type: SET_CLAZZ_MEMBERS,
    payload: members
});

const setTeachMode = mode => ({
    type: SET_TEACH_MODE,
    payload: mode
});

const setChatSteps = steps => ({
    type: SET_CHAT_STEPS,
    payload: steps
});

const setChatButtons = buttons => ({
    type: SET_CHAT_BUTTONS,
    payload: buttons
});

const setStepProgress = progress => ({
    type: SET_STEP_PROGRESS,
    payload: progress
});

const setStepMode = mode => ({
    type: SET_STEP_MODE,
    payload: mode
});

//控制各种对话框的开闭
const openModal = modal => ({
    type: OPEN_MODAL,
    payload: modal
});

const closeModal = modal => ({
    type: CLOSE_MODAL,
    payload: modal
});


const openLoginModal = () => openModal(MODAL_LOGIN);
const closeLoginModal = () => closeModal(MODAL_LOGIN);

// 设置是否有聊天框
const setChatBox = isChatBox => ({
    type: SET_CHAT_BOX,
    payload: isChatBox
})

// 是否移动端
const setPhone = isPhone => ({
    type: SET_PHONE,
    payload: isPhone
})

const setKeybord = keyboard => ({
    type:SET_KEYBORD,
    payload: keyboard
})

export {
    teachReducer as default,
    teachInitialState,
    setUser,
    logout,
    setProjectInfo,
    setEditMode,
    setRecommendedProjects,
    setMyProjects,
    setMyShareProjects,
    setCourses,
    setCourse,
    setCourseRecords,
    setCourseMembers,
    setLesson,
    setLessonMembers,
    setClazzes,
    setClazz,
    setClazzMembers,
    setTeachMode,
    setChatSteps,
    setChatButtons,
    setStepProgress,
    setStepMode,
    openLoginModal,
    closeLoginModal,
    setChatBox,
    setPhone,
    setKeybord
}
